<div class="my-2">
  <form [formGroup]="formData">
    <label *ngIf="group.name === 'personal details'">{{
      question.label
    }}</label>
    <div class="input-group" id="timepicker-input-group1">
      <input
        class="form-control flatpickr-input"
        formControlName="field"
        type="text"
        mwlFlatpickr
        [noCalendar]="true"
        [enableTime]="true"
        [dateFormat]="'H:i'"
        [altInput]="true"
        [altFormat]="'h:i K'"
        [ngClass]="{ 'is-invalid': form.field.errors }" />
      <span class="input-group-text"
        ><i class="mdi mdi-clock-outline"></i
      ></span>
    </div>

    <div
      class="mt-2"
      *ngIf="form.field.errors"
      style="font-size: 80%; color: rgb(244 106 106)">
      <span *ngIf="form.field.errors.required"
        >Please provide a valid response.</span
      >
    </div>
  </form>
</div>
